<template>
<div class="create_user">
  <v-container>
    <v-row justify="center">
      <v-col md="6">
        <v-form @submit.prevent="createUser">
          <v-text-field
            v-model="email"
            type="text"
            autocomplete="email"
            label="E-mail"
            :rules="emailRules"
          ></v-text-field>
          
          <v-text-field
            v-model="username"
            type="text"
            autocomplete="username"
            label="Username"
            :rules="usernameRules"
          ></v-text-field>
          
          <v-text-field
            v-model="password"
            type="password"
            autocomplete="new-password"
            label="Password"
            :rules="passwordRules"
          ></v-text-field>
          
          <v-text-field
            v-model="repeatedPassword"
            type="password"
            autocomplete="new-password"
            label="Confirm Password"
            :rules="repeatedPasswordRules"
          ></v-text-field>
          
          <v-btn color="primary" type="submit">Create</v-btn>
        </v-form>
      
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import apiClient from "@/utils/apiClient";
import validators from "@/utils/validators";

export default {
  data: () => ({
    email: "",
    username: "",
    password: "",
    repeatedPassword: "",
    
    emailRules: [
      value => !!value || 'Required.',
      value => validators.isEmail(value) || "Invalid e-mail",
    ],
    usernameRules: [
      value => !!value || "Required",
    ],
    passwordRules: [
      value => !!value || "Required",
      value => value.length > 5 || "Minimum 6 characters",
    ],
    repeatedPasswordRules: [],
  }),
  computed: {
    form() {
      return {
        email: this.email,
        username: this.username,
        password: this.password,
      }
    },
  },
  mounted() {
    this.setUpMissingRules()
  },
  methods: {
    setUpMissingRules() {
      this.repeatedPasswordRules = [
        value => !!value || "Required",
        value => value === this.password || "Passwords must match",
      ]
    },
    createUser() {
      if (!this.isFormValid())
        return;
      
      apiClient
        .createUser(this.form)
        .then(() => {
          this.$router.push({ name: 'home' })
        })
        .catch((error) => {
          console.log(error)
        })
    },
  
    isFormValid() {
      return this.emailRules.every(validation => validation(this.email) === true)
        && this.usernameRules.every(validation => validation(this.username) === true)
        && this.passwordRules.every(validation => validation(this.password) === true)
        && this.repeatedPasswordRules.every(validation => validation(this.repeatedPassword) === true)
    },
  },
}
</script>
